import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './index.scss'
import { TweenMax, Power0, Power2, Power3 } from 'gsap'
// import $ from 'jquery'
const imagesLoaded = require('imagesloaded')

class EntryPoster extends Component {
  componentDidMount () {
    imagesLoaded(this.container, { background: '.entry-poster__inner' }, () => {
      TweenMax.to(this.container, 0.8, { x: '0%', ease: Power3.easeInOut })
      TweenMax.fromTo(this.inner, 0.8, { x: '60%' }, { x: '0%', ease: Power3.easeInOut })
      TweenMax.fromTo(this.inner, 0.8, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power0.easeNone })
    })
  }

  componentWillLeave (callback) {
    TweenMax.to(this.container, 0.8, { x: '-100%', ease: Power3.easeInOut, onComplete: callback })
    TweenMax.to(this.inner, 0.8, { x: '60%', ease: Power3.easeInOut })
    TweenMax.to(this.inner, 0.8, { autoAlpha: 0, ease: Power0.easeNone })
  }

  // componentWillEnter (callback) {
  //   TweenMax.to(this.container, 0.6, { width: 0, ease: Power2.easeOut, onComplete: callback })
  // }

  render () {
    return (
      <div ref={el => { this.container = el }} className='entry-poster'>
        <div ref={el => { this.inner = el }} className='entry-poster__inner' style={{ backgroundImage: `url(${this.props.image})` }} />
      </div>
    )
  }
}

EntryPoster.propTypes = {
  image: PropTypes.string
}

export default EntryPoster



// WEBPACK FOOTER //
// ./src/components/EntryPoster/index.js